import {
  useGetPlaybookQuery,
  useUpdatePlaybookMutation,
} from '@carboncopyco/data';
import { PermissionAction, PermissionKey } from '@carboncopyco/types';
import { LoadingDots, TextCaption, TextLargeParagraph } from '@carboncopyco/ui';
import { MMMDoYYYY } from '@carboncopyco/utils';
import { usePermissionsContext } from '../../../utils';
import { TitleCard } from '../../InfoPageCards';
import { InfoPageEditableDescription } from '../../InfoPageEdiableDescription';
import { usePlaybookPageProps } from '../PlaybookPageContext';

export const DetailsCard = () => {
  const { organizationId, workspaceId, playbookId, readOnly } =
    usePlaybookPageProps();
  const { getPermissions } = usePermissionsContext();
  const { data: playbook } = useGetPlaybookQuery({
    organizationId,
    workspaceId,
    id: playbookId,
  });
  const [updatePlaybook] = useUpdatePlaybookMutation();

  const updatePlaybookPermission = getPermissions(
    PermissionKey.playbook,
    PermissionAction.updatePlaybookById
  );

  const { description, creator, createTime } = playbook || {};

  const defaultDescription = `Created by ${creator?.firstName} ${
    creator?.lastName
  }, on ${MMMDoYYYY(createTime)}`;

  return (
    <TitleCard
      header={
        <div className="flex justify-between items-center px-6 h-ds-15">
          <TextLargeParagraph
            color="text-ds-natural-700"
            label="Details"
          />
        </div>
      }
      radius
    >
      <div className="flex flex-col gap-1 p-6 h-60">
        {playbook ? (
          <>
            <TextCaption label="Description" />
            <div className="max-w-ds-96">
              <InfoPageEditableDescription
                description={description || defaultDescription}
                disabled={readOnly || !updatePlaybookPermission}
                onDescriptionChange={(value) =>
                  updatePlaybook({
                    id: playbookId,
                    workspaceId,
                    organizationId,
                    description: value,
                    withOptimisticUpdate: true,
                  })
                }
              />
            </div>
          </>
        ) : (
          <div className="h-full flex items-center justify-center">
            <LoadingDots />
          </div>
        )}
      </div>
    </TitleCard>
  );
};
